import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const jobIsReadyForTranscribing = (status: keyof typeof JOB_STATUSES_ENUM) => {
  return JOB_STATUSES_ENUM[status] === JOB_STATUSES_ENUM.JOB_STATUS_READY_FOR_TRANSCRIBING;
};
